import type { ComponentProps } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Column } from '../box';
import { useKeyboardResponsiveViewKeyboardVisible } from '../keyboard-responsive-view';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

interface AccessoryProps extends Omit<ComponentProps<typeof Column>, 'marginBottom' | 'marginTop'> {
  elevated?: boolean;
  marginBottom?: number;
  marginTop?: number;
}

export function Accessory({
  children,
  elevated,
  style,
  marginTop,
  marginBottom,
  backgroundColor,
  ...rest
}: AccessoryProps) {
  const insets = useSafeAreaInsets();
  const keyboardVisible = useKeyboardResponsiveViewKeyboardVisible();

  return (
    <Column
      {...(elevated && {
        elevation: 20,
        shadowColor: 'text.primary',
        shadowOffset: { height: 0, width: 0 },
        shadowOpacity: 0.15,
        shadowRadius: 7.5,
      })}
      {...rest}
      backgroundColor={backgroundColor ?? 'surface.default'}
      style={[
        style,
        {
          paddingBottom:
            marginBottom ??
            (keyboardVisible
              ? theme.spacing['spacing.general.x2']
              : insets.bottom || theme.spacing['spacing.general.x4']),
          paddingTop: marginTop,
        },
      ]}
    >
      {children}
    </Column>
  );
}
